<div class="page">
  <div class='page-wrapper'>

    <div class="header-wrapper">
      <div *ngIf="currentImage" class="img-wrapper">
        <!--
                <img [src]="banner_sponsor">
        currentImage-->
        <img [src]="currentImage" style="width: 100%;" [class.active]="activeImage">
        <img [src]="currentImage" style="width: 100%;" [class.active]="!activeImage">
        <!--
        <img [src]="banner_sponsor" style = "width: 79%; margin: auto;" [class.active]="!activeImage">
        -->
      </div>
    </div>

    <div class="body-wrapper">

      <div class="body-left-wrapper">

        <mat-select placeholder="Data" [ngModel]='selectedDay' (ngModelChange)='selectDay($event)'>
          <mat-option *ngFor="let day of days" [value]="day.id">
            <span>{{day.name}}</span>
          </mat-option>
        </mat-select>

        <mat-select placeholder="Sala" [ngModel]='selectedRoom' (ngModelChange)='selectRoom($event)'>
          <mat-option *ngFor="let room of rooms" [value]="room.id">
            <span>{{room.name.substr(3)}}</span>
          </mat-option>
        </mat-select>

        <mat-select placeholder="Atividade" [ngModel]='selectedDepto' (ngModelChange)='selectDepartent($event)'>
          <mat-option *ngFor="let depto of deptos" [value]="depto.id">
            <span>{{depto.name}}</span>
          </mat-option>
        </mat-select>

        <mat-select placeholder="Palestrante" [ngModel]='selectedSpeaker' (ngModelChange)='selectSpeaker($event)'>
          <mat-option *ngFor="let speaker of speakers" [value]="speaker.id">
            <span>{{speaker.name}}</span> <span *ngIf="speaker.state"> ({{speaker.state}})</span>
          </mat-option>
        </mat-select>

        <button style="margin: 20px auto 10px auto;" (click)="filter()">
          Filtrar
        </button>

        <button style="margin: 10px auto 20px auto;" (click)="clearFilters()">
          Limpar filtros
        </button>

      </div>

      <div class="body-right-wrapper">

        <!--
        <div class="banner">
          <img style="width: 100%;" [src]="banner_sponsor" />
        </div>
        -->

        <div class="criteria">
          {{criteria}}
        </div>

        <div style="width: 100%; text-align: center;" *ngIf="notFound">

          <p style="margin-top: 50px; color: darkorange; font-size: 1.4em;">Nenhuma atividade encontrada <br> para os
            filtros selecionados</p>
          <br>
          <button mat-button style="background-color: darkorange; color: white;" (click)="clearFilters()">
            Limpar filtros
          </button>
          <br><br> <br><br>
        </div>

        <div *ngIf="isSpeaker" class='speaker-box'>
          <div class="speaker-left">
            <img [src]='member_image' *ngIf="member_image">
          </div>
          <div class="speaker-right" [innerHTML]="member_text">
          </div>
        </div>

        <div class="schedule" *ngIf="_activities.length > 0">

          <div *ngFor="let activity of _activities">

            <div class="activity-title-1">
              <span>{{activity.date }} &bull; {{activity.location.substr(3)}}</span>
            </div>

            <div class="activity-title-2">
              <div style="padding-bottom: 5px; color: gold">
                {{activity.depto}}
              </div>

              <div [innerHTML]='activity.depto_text' style="color:whitesmoke;"></div>

              <a *ngIf="activity.sponsor" target="_blank" [href]="activity.sponsor.link">
                <img style="width:100%; margin: 5px 0 10px 0;" [src]="activity.sponsor.image">
              </a>

              <div style="padding-top: 5px; font-size: 1em;">
                <b>{{activity.startTime}}</b> - {{activity.name}}
              </div>
            </div>

            <div class="activity-display">

              <ul *ngFor="let aga of activity.agenda">
                <div *ngIf="aga.member_id === selectedSpeaker">
                  <li style="color: blue;">{{aga.member_name}} - {{aga.role_name}}</li>
                </div>
                <div *ngIf="aga.member_id !== selectedSpeaker">
                  <li> {{aga.member_name}} - {{aga.role_name}}</li>
                </div>

              </ul>

              <div *ngFor="let topic of activity.topics">

                <div class="topic-title-1">
                  <span><b>{{topic.startTime}}</b></span> - {{topic.name}}
                </div>

                <div class="topic-display">
                  <ul *ngFor="let agt of topic.agenda">
                    <div *ngIf="agt.member_id === selectedSpeaker">
                      <li style="color: blue;">{{agt.member_name}} - {{agt.role_name}}</li>
                    </div>
                    <div *ngIf="agt.member_id !== selectedSpeaker">
                      <li> {{agt.member_name}} - {{agt.role_name}}</li>
                    </div>
                  </ul>
                </div>

              </div>

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
</div>